// Copyright 2022, Imprivata, Inc.  All rights reserved.

import { useMutation } from '@tanstack/react-query';
import { updateWorkflowId } from '@tracing/index';
import { generateWorkflowId, getWorkflowIdFromUrl } from '@utils/WorkflowIdHelper';
import { apiClient } from '../client';

const postGrantRequest = async (): Promise<void> => {
  // Create a form that submits to the grant endpoint so the browser can handle the 302 redirect from Post grant API
  const form = document.createElement('form');
  form.method = 'POST';

  const url = new URL('grant', apiClient.baseUrl); // handles slashes safely
  const workflowId = getWorkflowIdFromUrl() || generateWorkflowId();
  updateWorkflowId(workflowId);
  url.searchParams.set('Impr-Workflow-Id', workflowId);

  form.action = url.toString();
  form.style.display = 'none';

  // Append form to body and submit
  document.body.appendChild(form);
  form.submit();
};

export const usePostGrantMutation = (options?: { onSuccess?: () => void }) => {
  const mutation = useMutation({
    mutationFn: () => postGrantRequest(),
    onSuccess: () => {
      options?.onSuccess?.();
    },
  });

  return {
    postGrant: mutation.mutate,
    isPending: mutation.isPending,
    isSuccess: mutation.isSuccess,
  };
};
